import styled from "styled-components";

export const ProjectContainer = styled.ul`
    display: flex;
    flex-wrap: wrap;
    margin-top: 1.875rem;
`;
